import * as ambassadorWixEcomOrdersV1Invoice from './ecom-orders-v1-invoice-order-invoices.http.js';
import * as ambassadorWixEcomOrdersV1InvoiceTypes from './ecom-orders-v1-invoice-order-invoices.types.js';
import * as ambassadorWixEcomOrdersV1InvoiceUniversalTypes from './ecom-orders-v1-invoice-order-invoices.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listInvoicesForMultipleOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.ListInvoicesForMultipleOrdersRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.ListInvoicesForMultipleOrdersRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.ListInvoicesForMultipleOrdersResponse,
  ambassadorWixEcomOrdersV1InvoiceTypes.ListInvoicesForMultipleOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.listInvoicesForMultipleOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/list-by-ids',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateInvoice(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.GenerateInvoiceRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.GenerateInvoiceRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.GenerateInvoiceResponse,
  ambassadorWixEcomOrdersV1InvoiceTypes.GenerateInvoiceResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.generateInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/orders/{orderId}',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGenerateInvoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.BulkGenerateInvoicesRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.BulkGenerateInvoicesRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.BulkGenerateInvoicesResponse,
  ambassadorWixEcomOrdersV1InvoiceTypes.BulkGenerateInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.bulkGenerateInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/invoices/generate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addInvoiceToOrder(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.AddInvoiceToOrderRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.AddInvoiceToOrderRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.AddInvoiceToOrderResponse,
  ambassadorWixEcomOrdersV1InvoiceTypes.AddInvoiceToOrderResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.addInvoiceToOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/orders/{orderId}/add-invoice',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Invoice as InvoiceOriginal,
  ListInvoicesForSingleOrderRequest as ListInvoicesForSingleOrderRequestOriginal,
  ListInvoicesForSingleOrderResponse as ListInvoicesForSingleOrderResponseOriginal,
  ListInvoicesForMultipleOrdersRequest as ListInvoicesForMultipleOrdersRequestOriginal,
  ListInvoicesForMultipleOrdersResponse as ListInvoicesForMultipleOrdersResponseOriginal,
  InvoicesForOrder as InvoicesForOrderOriginal,
  GenerateInvoiceRequest as GenerateInvoiceRequestOriginal,
  GenerateInvoiceResponse as GenerateInvoiceResponseOriginal,
  BulkGenerateInvoicesRequest as BulkGenerateInvoicesRequestOriginal,
  BulkGenerateInvoicesResponse as BulkGenerateInvoicesResponseOriginal,
  BulkInvoiceResult as BulkInvoiceResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  InvoiceForOrder as InvoiceForOrderOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  AddInvoiceToOrderRequest as AddInvoiceToOrderRequestOriginal,
  AddInvoiceToOrderResponse as AddInvoiceToOrderResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  GetOrderInvoiceRequest as GetOrderInvoiceRequestOriginal,
  GetOrderInvoiceResponse as GetOrderInvoiceResponseOriginal,
  GenerateInvoiceWithNumberRequest as GenerateInvoiceWithNumberRequestOriginal,
  GenerateInvoiceWithNumberResponse as GenerateInvoiceWithNumberResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GenerateInvoiceApplicationErrors as GenerateInvoiceApplicationErrorsOriginal,
} from './ecom-orders-v1-invoice-order-invoices.types.js';
